import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CustomSnackbar from "../../Sections/Common/snackBar";

const Spinner = ({ path = "" }) => {
    const [count, setCount] = useState(2);
    const navigate = useNavigate();
    const location = useLocation();
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCount((prevValue) => --prevValue);
        }, 500);

        if (count === 0) {
            setSnackbar({
                open: true,
                message: "Session expired! Please login again.",
                severity: "error",
            });
            setTimeout(() => {
                navigate(`/login`, {
                    state: location.pathname,
                });
            }, 2000);
        }
        return () => clearInterval(interval);
    }, [count, navigate, location, path]);

    return (
        <>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};
export default Spinner;
